import React, {useState, useEffect, useCallback, useRef} from 'react';
import { useDispatch } from "react-redux";
import { ScalingContainer } from "../../../AppStyled";

import { ReactComponent as SonicSVG } from "../../../svg/SONICa.svg";
import { ReactComponent as Keno40SVG } from "../../../svg/keno40.svg";
import { ReactComponent as Keno80SVG } from "../../../svg/keno80.svg";
import { LoadingDiv, Orange, Yellow, Purple, White } from "./LoadingStyled";
import {
  toggleChangingMode,
  turnMode,
} from "../../../redux/actions/postActions";
import { Globals } from "../../../lib/constants";
// import { useSendSettings } from "../settings/useSendSettings";

import useSound from "use-sound";
import loadingSound from "../../../audio/Loader.mp3";

export default function Loading({
  isLoaded,
  isShaking,
  isShakingPurple,
  kenoFadeIn,
  coordinates: { yl, yt, ol, ot, wl, wt, pl, pt },
  sound,
  volume,
  music,
}) {
  const [chosen, setchosen] = useState(false);
  const [showText, setshowText] = useState(true);
  const [loadingSfx, loadingSfxObj] = useSound(loadingSound, { volume });
  const [firstRender, setfirstRender] = useState(true);
  const modeChosen = useRef(false);

  useEffect(() => {
    if (music) {
      if (firstRender) {
        loadingSfx();
        setfirstRender(false);
      }
    }
    return () => loadingSfxObj.stop();
  }, [music, loadingSfx, loadingSfxObj, firstRender]);
  useEffect(() => { }, []);
  const handleChoose = (c) => {
    setTimeout(() => {
      setshowText(false);
    }, 1200);
    if (!chosen) {
      setchosen(c);
      setTimeout(() => {
        switch (c) {
          case "yellow":
            kenoFadeIn("sonic");
            break;
          case "orange":
            kenoFadeIn("40");
            break;
          case "purple":
            kenoFadeIn("80");
            break;

          default:
            break;
        }
      }, 400);
    }
  };
  const dispatch = useDispatch();
  // const st = useSelector(
  //   (s) => s,
  //   () => {}
  // );
  // const {
  //   userSettings: { sound, music, volume },
  // } = st;

  // const [sound, setsound] = useState(sound);
  // const [music, setmusic] = useState(music);
  // const [fullScreenH, setfullScreenH] = useState(fullScreen);
  // const [volume, setvolume] = useState(volume);
  // useEffect(() => {
  //   setsound(sound);
  //   setmusic(music);
  //   setvolume(volume);
  // }, [sound, music, volume]);

  // const [send] = useSendSettings();
  const [intViewportHeight, setintViewportHeight] = useState(667);

  const handleResize = useCallback((a) => {
    if (window.innerHeight < 667) {
      setintViewportHeight(window.innerHeight);
    }
  }, []);


  const handleMode = (ball, mode) => {
    if(modeChosen.current) return
    modeChosen.current = true
    Globals.WS && Globals.WS.Disconnect();
    handleChoose(ball);
    dispatch(turnMode(mode));
    dispatch(toggleChangingMode(false));
    // setTimeout(() => {
    //   Globals.WS = new WS().Init(this).Start();
    // }, 1000)
  }


  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
  }, [handleResize]);
  return (
    <ScalingContainer
      style={{ position: "absolute" }}
      className="ScalingContainer"
      h={intViewportHeight}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <LoadingDiv>
          <Yellow
            className="yellow"
            isLoaded={isLoaded}
            isShaking={isShaking}
            chosen={chosen}
            showText={showText}
            onClick={() => handleMode('yellow', 'sonic')
            }
            c={{ yl, yt }}
          >
            {isLoaded && <SonicSVG />}
          </Yellow>
          <Orange
            className="orange"
            isLoaded={isLoaded}
            isShaking={isShaking}
            showText={showText}
            chosen={chosen}
            onClick={() => handleMode('orange', '40')}
            c={{ ol, ot }}
          >
            {isLoaded && <Keno40SVG />}
          </Orange>
          <Purple
            className="purple"
            isLoaded={isLoaded}
            showText={showText}
            isShakingPurple={isShakingPurple}
            chosen={chosen}
            onClick={() => handleMode('purple', '80')}
            c={{ pl, pt }}
          >
            {isLoaded && <Keno80SVG />}
          </Purple>
          <White
            className="white"
            isLoaded={isLoaded}
            isShaking={isShaking}
            chosen={chosen}
            c={{ wl, wt }}
          />
        </LoadingDiv>
      </div>
    </ScalingContainer>
  );
}
